import { render, staticRenderFns } from "./user-activities.vue?vue&type=template&id=7e216850&"
import script from "./user-activities.vue?vue&type=script&lang=js&"
export * from "./user-activities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports